import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { AdminResourceDetailView } from '@/components/admin/AdminResourceDetailView';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';

export const Route = createFileRoute('/_authed/admin/resources/$id')({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.id)) throw notFound();
  },
  component: AdminResourceDetailPage,
});

function AdminResourceDetailPage() {
  const { id } = Route.useParams();
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="resources">
      <AdminResourceDetailView id={id} />
    </AdminShell>
  );
}
